import React from 'react';
import { CrawlFbResponse } from '../../../../../api/crawlFb';

interface FailedStatusProps {
  crawlData: CrawlFbResponse;
  onRetry: () => void;
  isShowNewCrawl: boolean;
}

const FailedStatus: React.FC<FailedStatusProps> = ({
  crawlData,
  onRetry,
  isShowNewCrawl,
}) => {
  return (
    <div className="bg-red-50 border border-red-200 rounded-lg p-4">
      <div className="flex items-center justify-between mb-4">
        <div className="flex items-center">
          <svg
            className="h-5 w-5 text-red-500 mr-3"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm1 15h-2v-2h2v2zm0-4h-2V7h2v6z" />
          </svg>
          <div>
            <h4 className="text-red-800 font-medium flex items-center">
              <span className="mr-2">❌</span>
              Crawl thất bại
            </h4>
            <p className="text-red-700 text-sm mt-1">
              Đã xảy ra lỗi trong quá trình crawl hoặc xử lý ảnh
            </p>
          </div>
        </div>

        {isShowNewCrawl && (
          <button
            onClick={onRetry}
            className="px-4 py-2 bg-red-600 text-white rounded-lg hover:bg-red-700 transition-colors text-sm font-medium"
          >
            🔄 Thử lại
          </button>
        )}
      </div>

      {/* Progress indicator - failed */}
      <div className="mb-4">
        <div className="flex items-center text-xs text-red-600">
          <div className="flex-1 bg-red-200 rounded-full h-2 mr-3">
            <div
              className="bg-red-500 h-2 rounded-full"
              style={{ width: '100%' }}
            ></div>
          </div>
          <span>Thất bại</span>
        </div>
      </div>

      {/* Error Details */}
      {crawlData.errorMessage && (
        <div className="bg-white rounded-lg p-4 border border-red-200 mb-4">
          <h5 className="font-medium text-red-800 mb-2 flex items-center">
            <span className="mr-2">🐛</span>
            Chi tiết lỗi:
          </h5>
          <div className="bg-red-50 p-3 rounded border border-red-100">
            <code className="text-red-700 text-sm whitespace-pre-wrap">
              {crawlData.errorMessage}
            </code>
          </div>
        </div>
      )}

      {/* Troubleshooting Tips */}
      <div className="bg-white rounded-lg p-4 border border-red-200">
        <h5 className="font-medium text-red-800 mb-3 flex items-center">
          <span className="mr-2">💡</span>
          Gợi ý khắc phục:
        </h5>
        <ul className="space-y-2 text-sm text-red-700">
          <li className="flex items-start">
            <span className="mr-2">•</span>
            Kiểm tra lại cookies có còn hợp lệ không
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            Đảm bảo URL Facebook là công khai hoặc bạn có quyền truy cập
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            Thử đăng nhập lại Facebook và lấy cookies mới
          </li>
          <li className="flex items-start">
            <span className="mr-2">•</span>
            Kiểm tra kết nối mạng và thử lại sau vài phút
          </li>
        </ul>
      </div>
    </div>
  );
};

export default FailedStatus;
